import type { AssistantAnswer, AssistantQuestion } from "@stores/assistant";

export function hasAnswer(answer: AssistantAnswer | undefined): boolean {
  return Array.isArray(answer) ? answer.length > 0 : Boolean(answer);
}

export function answerIncludes(answer: AssistantAnswer | undefined, option: string): boolean {
  return Array.isArray(answer) ? answer.includes(option) : answer === option;
}

// The answers become the next user message, so they travel twice: as text for
// the model, and indexed for the form to stay readable later. The text keeps
// each wording for context but drops its question mark: sent back verbatim,
// the model read its own form as a new set of questions and asked them again.
export function answersMessage(questions: AssistantQuestion[], answers: Record<string, AssistantAnswer>): string {
  const lines = questions.map((item, index) => {
    const answer = answers[String(index)] ?? "";
    const text = Array.isArray(answer) ? answer.join(", ") : answer;
    return `- ${item.question.trim().replace(/\s*\?+$/, "")} → ${text}`;
  });
  return ["Answers:", ...lines].join("\n");
}
